<div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-md-12">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a [routerLink]="['/home']">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a>Site Types</a>
        </li>
      </ol>
    </div>
  </div>

  <div class="modal fade" bsModal #addItemModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">ADD SITE TYPE</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="addItemModal.hide()"></button>
        </div>
        <div class="modal-body">
          <div class="row" *ngIf="newSiteType">
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Site Type Code</label>
                <div class="input-group m-b">
                    <input type="text" [(ngModel)]="newSiteType.siteTypeCode" class="form-control"/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Description</label>
                <div class="input-group m-b">
                    <input type="text" [(ngModel)]="newSiteType.description" class="form-control"/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">

              <div class="form-check form-switch">
                <input type="checkbox" class="form-check-input" id="visibleSwitch" [(ngModel)]="newSiteType.visible" >
                <label class="form-check-label" for="visibleSwitch">Visible</label>
              </div>

            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button (click)="addItemModal.hide()" class="btn btn-white">Cancel</button>
          <button (click)="saveNewItem();addItemModal.hide()" class="btn btn-white">Add</button>
        </div>
      </div>
    </div>
  </div>


  <div class="modal fade" bsModal #updateItemModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">UPDATE SITE TYPE</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="updateItemModal.hide()"></button>
        </div>
        <div class="modal-body">
          <div class="row" *ngIf="siteType">
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Site Type Code</label>
                <div class="input-group m-b">
                    <input type="text" [(ngModel)]="siteType.siteTypeCode" class="form-control"/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Description</label>
                <div class="input-group m-b">
                    <input type="text" [(ngModel)]="siteType.description" class="form-control"/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <div class="form-check form-switch">
                  <br/>
                  <input type="checkbox" class="form-check-input" id="visibleSwitch" [(ngModel)]="siteType.visible" >
                  <label class="form-check-label" for="visibleSwitch">Visible</label>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Map Pin Behaviour</label>
                <div class="input-group m-b">
                    <select class="form-select" [(ngModel)]="siteType.displayMode">
                      <option value="0">Default</option>
                      <option value="1">Wind Barb</option>
                      <option value="2">Camera</option>
                    </select>
                    <button class="btn  btn-outline-default" (click)="showPinMenu = !showPinMenu"><img style="height:22px" [title]="siteType.mapPinId" src="{{icons.getPinIconById(siteType.mapPinId)}}"/></button>
                    <div class="toggle-menu" *ngIf="showPinMenu">
                        <button class="btn btn-outline-default btn-sm" *ngFor="let pin of icons.pinDetails" (click)="siteType.mapPinId=pin.id"><img style="height:22px" src="/{{pin.iconUrl}}"/></button>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button (click)="updateItemModal.hide()" class="btn btn-white">Cancel</button>
          <button (click)="updateSiteType();updateItemModal.hide()" class="btn btn-white">Save</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" bsModal #fieldDeployModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">FIELD DEPLOY : <span *ngIf="siteType">{{siteType.siteTypeCode}}</span></h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="fieldDeployModal.hide()"></button>
        </div>
        <div class="modal-body">
          <div *ngIf="siteType">
            <tabset>
              <tab [heading]="at.name" *ngFor="let at of activityTypes">
                <div class="row dialogNewRecord">
                  <div class="col-12">
                    <i *ngIf="at.description">{{at.description}}</i>
                    <ng-container *ngIf="activityPlans && getActivityPlanForType(at) as activityPlan">

                      <ng-template #itemTemplate let-item="item" let-index="index">
                        <div class="row">
                          <div class="col-1 text-center align-self-center">
                            <span class="handle" style="cursor:move"><i class="fa fa-bars"></i></span>
                          </div>
                          <div class="col-3">
                            <label>Site Name</label>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="item.value.name" placeholder="Step Name" maxlength="50" [ngClass]="{'is-invalid':item.value.name == null || item.value.name == ''}"/>
                          </div>
                          <div class="col-3">
                            <label>Description</label>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="item.value.description" placeholder="Description" maxlength="100"/>
                          </div>
                          <div class="col-3">
                            <label>Data Type</label>
                            <select class="form-select form-select-sm" [(ngModel)]="item.value.dataType" [ngClass]="{'is-invalid':item.value.dataType == null}">
                              <option value="0">String</option>
                              <option value="1">Float</option>
                              <option value="2">Integer</option>
                              <option value="3">Boolean</option>
                              <option value="4">Select</option>
                              <option value="5">Photo</option>
                              <option value="6">Location</option>
                            </select>
                          </div>
                          <div class="col-1">
                            <label>Mandatory</label>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" [(ngModel)]="item.value.mandatory" >
                            </div>
                          </div>
                          <div class="col-1 text-center align-self-center">
                            <button class="btn btn-outline-danger btn-sm mt-4" (click)="removeStep(activityPlan, index)"><i class="fa fa-trash"></i></button>
                          </div>
                        </div>
                        <div class="row" *ngIf="item.value.dataType == 4">
                          <div class="col-12">
                            <label>Options</label>
                            <tag-editor [(tags)]="item.value.selectOptions"></tag-editor>
                          </div>
                        </div>
                      </ng-template>

                      <div *ngIf="activityPlan">
                        <div class="row">
                          <div class="col-4">
                            <button class="btn btn-outline-default btn-sm mb-2" (click)="addStep(activityPlan)"><i class="fa fa-plus"></i> Add Step</button>
                          </div>
                          <!--<div class="col-4">
                            <div class="form-check form-switch">
                              <input type="checkbox" class="form-check-input" id="visibleSwitch" [(ngModel)]="activityPlan.locationRequired" >
                              <label class="form-check-label" for="visibleSwitch">Location Required</label>
                            </div>
                          </div>
                          <div class="col-4">
                            <div class="form-check form-switch">
                              <input type="checkbox" class="form-check-input" id="visibleSwitch" [(ngModel)]="activityPlan.photosRequired" >
                              <label class="form-check-label" for="visibleSwitch">Photos Required</label>
                            </div>
                          </div>-->
                        </div>
                        <!-- Sortable list of -->
                        <bs-sortable
                          [(ngModel)]="activityPlan.activityConfig"
                          (onChange)="onOrderChange($event, activityPlan)"
                          itemClass="list-group-item"
                          [itemTemplate]="itemTemplate"
                          itemActiveClass="sortable-item-active"
                          placeholderItem="Add A Step"
                          placeholderClass="list-group-item text-center bg-green bg-opacity-30 h-100px"
                          wrapperClass="list-group bg-emphasis bg-opacity-25">
                        </bs-sortable>

                        <div class="mt-2">
                          <button class="btn btn-outline-success btn-sm mb-2" (click)="saveActivityPlan(siteType, activityPlan)"><i class="fa fa-save"></i> Save Activity</button>
                        </div>
                      </div>

                      <div *ngIf="!activityPlans" class="alert alert-info mt-2">
                        Loading
                      </div>
                    </ng-container>
                  </div>
                </div>
              </tab>
              <tab [heading]="'Activity Events'">
                <div class="row dialogNewRecord">
                  <div class="col-12">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">User</th>
                          <th scope="col">Device EUI</th>
                          <th scope="col">Activity Type</th>
                          <th scope="col">Submitted Date</th>
                          <th scope="col">Processed Date</th>
                          <th scope="col">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let da of deviceActivities; let i = index">
                          <td>{{i + 1}}</td>
                          <td>{{da.activityUser}}</td>
                          <td>{{da.deviceId}}</td>
                          <td>{{da.activityPlan.activityType.name}}</td>  
                          <td>{{da.timeStamp | date}}</td>
                          <td>{{da.processedDateTime | date}}</td>
                          <td>
                            <button class="btn btn-outline-default btn-sm mr-2" (click)="toggleMetadata(da.id)" title="View Metadata"><i class="fa fa-eye"></i></button>
                            <button class="btn btn-outline-default btn-sm mr-2 btn-outline-danger" (click)="deleteActivity(da)"><i class="fa fa-trash"></i></button>
                            <button *ngIf="da.processedDateTime" class="btn btn-outline-default btn-sm" (click)="reprocessActivity(da)"><i class="fa fa-refresh"></i> Reprocess Activity</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </tab>
            </tabset>
          </div>
        </div>

        <!-- JSON Popup Component -->
        <app-json-popup
          [visible]="showMetadataForActivityId !== null"
          [title]="'Activity Metadata'"
          [jsonData]="getActivityById(showMetadataForActivityId)?.activityMetaData"
          [identifier]="getActivityById(showMetadataForActivityId)?.deviceId"
          [enableLinkFormatting]="true"
          [editable]="true"
          (close)="closeMetadata()"
          (update)="updateActivityMetadata($event)">
        </app-json-popup>

        <div class="modal-footer">
          <button (click)="fieldDeployModal.hide()" class="btn btn-outline-white">Cancel</button>
        </div>
      </div>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="card mt-2 bg-emphasis bg-opacity-25">
          <div class="card-body">
            <div class="d-flex fw-bold small mb-3">
              <span class="flex-grow-1">
                <button (click)="addSiteType();addItemModal.show()" class="btn btn-outline-default">Add New Site Type</button>
              </span>
            </div>
            <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Site Type Code</th>
                  <th scope="col">Description</th>
                  <th scope="col">Edit</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="service.loading">
                  <td colspan="6"><div class="spinner-border"></div></td>
                </tr>
                <tr *ngFor="let list of remoteData | async">
                  <td>{{list.siteTypeId}}</td>
                  <td>{{list.siteTypeCode}}</td>
                  <td>{{list.description}}</td>
                  <td>
                    <!-- edit template -->
                    <a class="btn btn-outline-default" (click)="siteType=list;updateItemModal.show()" title="Edit Site Type"><i class="fa fa-pencil"></i></a>
                    &nbsp;
                    <a class="btn btn-outline-default" (click)="showFieldDeploy(list);fieldDeployModal.show()" title="Edit Field Deploy"><i class="fa fa-tasks"></i></a>
                    &nbsp;
                    <!-- delete -->
                    <a class="btn btn-outline-danger ml-2" (click)="removeSitetype(list)" title="Delete Site Type"><i class="fa fa-trash"></i></a>

                  </td>
                  <td>
                    <button class="btn btn-outline-default" [routerLink]="'/site-type/' + list.siteTypeId">Open</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
